/* Arklavo Article v3 — Start Designing journey (calculator, fit toggles, sticky, FAQ enhance).
   Progressive enhancement only: every CTA is a server-rendered anchor to an exact PDP,
   the SKU pricing table remains the crawlable data source, and the baked FAQ block stays
   in server HTML (converted to accordions client-side, dedup-safe). No GoKickflip auto-open. */
(function () {
  'use strict';

  /* GA4 runs inside Shopify's sandboxed pixel (no page-level gtag/GTM), so dataLayer
     pushes never reach it. Events go direct via the Measurement Protocol, joined to the
     visitor's live GA4 session through the first-party _ga cookies. */
  var GA4_ID = 'G-6Q9TNZY596';
  function track(name, params) {
    try {
      var p = params || {};
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p));
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, p);
      }
      if (cfg && cfg.ga4) {
        var cm = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.([\d.]+)/);
        var sm = document.cookie.match(new RegExp('_ga_' + GA4_ID.slice(2) + '=GS\\d+\\.\\d+\\.s?(\\d+)'));
        var ev = Object.assign({
          engagement_time_msec: 100,
          page_location: location.href,
          page_title: document.title
        }, p);
        if (sm) ev.session_id = sm[1];
        var body = JSON.stringify({
          client_id: cm ? cm[1] : Date.now() + '.' + Math.floor(Math.random() * 1e9),
          events: [{ name: name, params: ev }]
        });
        var url = 'https://www.google-analytics.com/mp/collect?measurement_id=' + GA4_ID + '&api_secret=' + encodeURIComponent(cfg.ga4);
        if (navigator.sendBeacon) navigator.sendBeacon(url, body);
        else fetch(url, { method: 'POST', body: body, keepalive: true });
      }
    } catch (e) { /* analytics must never break the page */ }
  }

  var cfgEl = document.getElementById('a3-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = null; }
  if (!cfg) return;

  var state = {
    style: 'tee',
    fit: 'mens',
    topFit: 'mens',
    railFit: 'mens',
    qty: 12,
    started: false
  };

  /* Shopify Markets renders visitor-geo currency server-side; derive the live symbol
     from the server-rendered money string instead of hardcoding "$". */
  var symbol = '$';
  try {
    var sm = (cfg.top && cfg.top.mens && cfg.top.mens.money) || '$';
    var stripped = sm.replace(/[\d.,\s]/g, '');
    if (stripped) symbol = stripped;
  } catch (e) { /* keep default */ }

  function money(n) {
    return symbol + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function withParams(url, pos) {
    var joiner = url.indexOf('?') === -1 ? '?' : '&';
    return url + joiner + 'src=' + encodeURIComponent(cfg.src) + '&pos=' + pos;
  }

  function byId(id) { return document.getElementById(id); }

  function selectorStart() {
    if (state.started) return;
    state.started = true;
    track('selector_start', { article_slug: cfg.slug });
  }

  function selectorComplete() {
    track('selector_complete', {
      article_slug: cfg.slug,
      style: state.style,
      fit: state.fit,
      qty: state.qty
    });
  }

  /* ---------- calculator + recommendation ---------- */
  function rec() {
    var group = cfg.recs[state.style] || cfg.recs.tee;
    return group[state.fit] || group.mens;
  }

  function renderCalc(fromUser) {
    var r = rec();
    var per = r.price || 0;
    var perEl = byId('a3-perunit');
    var totEl = byId('a3-runtotal');
    var qtyOut = byId('a3-qtyout');
    if (perEl) perEl.textContent = per ? money(per) : 'See options';
    if (totEl) totEl.textContent = per ? money(per * state.qty) : 'See options';
    if (qtyOut) qtyOut.textContent = String(state.qty);

    var tag = byId('a3-rec-tag');
    var name = byId('a3-rec-name');
    var why = byId('a3-rec-why');
    var cta = byId('a3-rec-cta');
    if (tag) tag.textContent = r.tag;
    if (name) name.textContent = r.name;
    if (why) why.textContent = r.why;
    if (cta) {
      cta.setAttribute('href', withParams(r.url, 'rec'));
      cta.setAttribute('data-handle', r.handle);
    }
    if (fromUser) {
      track('recommendation_view', { article_slug: cfg.slug, product_handle: r.handle, style: state.style, fit: state.fit });
    }
  }

  function bindSegs(attr, apply) {
    var btns = [].slice.call(document.querySelectorAll('[' + attr + ']'));
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        selectorStart();
        apply(b.getAttribute(attr));
        selectorComplete();
      });
    });
  }

  bindSegs('data-a3-style', function (v) { state.style = v; renderCalc(true); });
  bindSegs('data-a3-fit', function (v) { state.fit = v; renderCalc(true); });

  var qtyInput = byId('a3-qty');
  function setQty(n) {
    state.qty = Math.max(1, n | 0);
    if (qtyInput) qtyInput.value = String(state.qty);
    renderCalc();
  }
  if (qtyInput) {
    qtyInput.addEventListener('input', function () {
      selectorStart();
      setQty(parseInt(qtyInput.value, 10) || 1);
      selectorComplete();
    });
  }
  var dec = byId('a3-dec');
  var inc = byId('a3-inc');
  if (dec) dec.addEventListener('click', function () { selectorStart(); setQty(state.qty - 1); selectorComplete(); });
  if (inc) inc.addEventListener('click', function () { selectorStart(); setQty(state.qty + 1); selectorComplete(); });

  /* ---------- hero top pick fit toggle ---------- */
  bindSegs('data-a3-fit-top', function (v) {
    state.topFit = v;
    var t = cfg.top[v] || cfg.top.mens;
    var name = byId('a3-top-name');
    var price = byId('a3-top-price');
    var cta = byId('a3-top-cta');
    if (name) name.textContent = t.name;
    if (price) price.textContent = t.money;
    if (cta) {
      cta.setAttribute('href', withParams(t.url, 'toppick'));
      cta.setAttribute('data-handle', t.handle);
    }
  });

  /* ---------- right rail fit toggle ---------- */
  bindSegs('data-a3-fit-rail', function (v) {
    state.railFit = v;
    var t = cfg.top[v] || cfg.top.mens;
    var cta = byId('a3-rail-cta');
    if (cta) {
      cta.setAttribute('href', withParams(t.url, 'rail'));
      cta.setAttribute('data-handle', t.handle);
    }
  });

  /* ---------- CTA clicks: analytics + GoKickflip modal routing ----------
     Hidden official Kickflip Customize Button blocks (one per product) each carry their own
     product-bound customizer modal. A click on any Start Designing CTA opens the modal for
     that CTA's current product by activating the matching Kickflip button. The href stays
     the exact PDP: no-JS visitors, crawlers, and open-in-new-tab keep a working route, and
     if the modal fails to appear the click falls back to normal navigation. */
  /* Kickflip blocks ship inside inert <template> tags (zero load cost). mountKf stamps one
     product's block into the DOM on intent; the component upgrades and binds on insertion. */
  /* Give every body h2 an anchor id (skip ids the body already ships) so the
     settings-driven TOC can link to any article's headings. */
  document.querySelectorAll('#a3-content h2').forEach(function (h) {
    if (!h.id) {
      h.id = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
    }
  });

  /* Convert standalone request-a-quote CTA buttons in the body into Start Designing
     CTAs bound to the hero product's designer modal. In-sentence quote mentions
     (plain inline links inside prose) are left untouched — no content loss. */
  if (cfg.top && cfg.top.mens) {
    document.querySelectorAll('#a3-content a[href*="request-quote"]').forEach(function (a) {
      var st = getComputedStyle(a);
      var btn = st.backgroundColor !== 'rgba(0, 0, 0, 0)' && st.backgroundColor !== 'transparent';
      var standalone = !a.closest('p');
      if (!standalone && !btn) return;
      a.textContent = 'Start Designing';
      a.setAttribute('href', withParams(cfg.top.mens.url, 'inline'));
      a.setAttribute('data-a3-cta', 'inline');
      a.setAttribute('data-handle', cfg.top.mens.handle);
    });
  }

  var kfTpls = {};
  var kfMap = {};
  if (cfg.designer) {
    document.querySelectorAll('.a3-kf-hosts template[data-kf]').forEach(function (t) {
      var h = (t.getAttribute('data-kf') || '').trim();
      if (h) kfTpls[h] = t;
    });
  }

  function mountKf(handle) {
    if (kfMap[handle]) return kfMap[handle];
    var t = kfTpls[handle];
    if (!t) return null;
    var host = document.createElement('div');
    host.appendChild(t.content.cloneNode(true));
    t.parentNode.insertBefore(host, t);
    kfMap[handle] = host.querySelector('customize-button') || null;
    return kfMap[handle];
  }

  function warmKf(handle) {
    if (handle && kfTpls[handle] && !kfMap[handle]) mountKf(handle);
  }

  function anyKickflipModalOpen() {
    return [].slice.call(document.querySelectorAll('.kickflip-modal')).some(function (m) {
      return getComputedStyle(m).display === 'flex';
    });
  }

  document.querySelectorAll('[data-a3-cta]').forEach(function (a) {
    ['pointerover', 'touchstart', 'focusin'].forEach(function (evt) {
      a.addEventListener(evt, function () { warmKf(a.getAttribute('data-handle') || ''); }, { passive: true });
    });
    a.addEventListener('click', function (e) {
      var handle = a.getAttribute('data-handle') || '';
      var kfBtn = cfg.designer ? mountKf(handle) : null;
      var toDesigner = false;
      if (kfBtn) {
        toDesigner = true;
        e.preventDefault();
        var dest = a.getAttribute('href');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            kfBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, composed: true, view: window }));
          });
        });
        /* Fallback navigates ONLY if the modal never opened at all. The moment it is seen
           open, the fallback is cancelled for good - closing the designer quickly must
           always leave the visitor on the article, never send them to the PDP. */
        var started = Date.now();
        var watcher = setInterval(function () {
          if (anyKickflipModalOpen()) { clearInterval(watcher); return; }
          if (Date.now() - started > 2500) {
            clearInterval(watcher);
            if (dest) window.location.href = dest;
          }
        }, 150);
      }
      track('start_designing_click', {
        article_slug: cfg.slug,
        pos: a.getAttribute('data-a3-cta'),
        product_handle: handle,
        fit: state.fit,
        style: state.style,
        qty: state.qty,
        designer: toDesigner ? 1 : 0
      });
    });
  });

  /* ---------- mobile sticky bar (dismissible, session-scoped) ---------- */
  (function () {
    var bar = byId('a3-sticky');
    if (!bar) return;
    var KEY = 'a3-sticky-dismissed';
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (e) { /* storage may be blocked */ }
    function onScroll() {
      if (dismissed) return;
      if (window.scrollY > 500) bar.classList.add('a3-sticky-on');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    var x = byId('a3-sticky-x');
    if (x) x.addEventListener('click', function () {
      dismissed = true;
      bar.classList.remove('a3-sticky-on');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* ignore */ }
    });
  })();

  /* ---------- baked FAQ block -> details accordions (content-preserving DOM move) ---------- */
  (function () {
    var content = byId('a3-content');
    if (!content) return;
    var faqH2 = content.querySelector('h2#faq') || [].slice.call(content.querySelectorAll('h2')).find(function (h) {
      return /frequently asked questions/i.test(h.textContent);
    });
    if (!faqH2) return;
    /* Only siblings BETWEEN the FAQ h2 and the next h2 are candidates (a flat article
       wrapper must never get its content boxes converted), the question must read like
       one, and EVERY child element moves into the accordion — tables and lists included. */
    var items = [];
    var node = faqH2.nextElementSibling;
    while (node && node.tagName !== 'H2') {
      if (node.tagName === 'DIV' && node.querySelectorAll('p').length >= 2) items.push(node);
      node = node.nextElementSibling;
    }
    items.forEach(function (item) {
      var qEl = item.querySelector('p');
      if (!qEl) return;
      var q = qEl.textContent.replace(/^\s*Q\.\s*/, '').trim();
      if (!q || q.length > 200 || !/\?\s*$/.test(q)) return;
      var details = document.createElement('details');
      details.className = 'a3-faqd';
      var summary = document.createElement('summary');
      var qp = document.createElement('p');
      qp.className = 'a3-faqq';
      qp.textContent = q;
      var pm = document.createElement('span');
      pm.className = 'a3-pm';
      pm.textContent = '+';
      qp.appendChild(pm);
      summary.appendChild(qp);
      details.appendChild(summary);
      var kids = [].slice.call(item.children);
      var moved = false;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i] === qEl) continue;
        if (kids[i].tagName === 'P') {
          kids[i].classList.add('a3-faqa');
          kids[i].removeAttribute('style');
        }
        details.appendChild(kids[i]);
        moved = true;
      }
      if (!moved) return;
      item.parentNode.replaceChild(details, item);
    });
  })();

  /* ---------- table scroll wrappers (mobile safety) ---------- */
  document.querySelectorAll('#a3-content table').forEach(function (t) {
    if (t.parentElement && t.parentElement.classList.contains('a3-tblwrap')) return;
    var wrapper = t.parentElement;
    if (wrapper && wrapper.getAttribute('style') && wrapper.getAttribute('style').indexOf('overflow-x:auto') !== -1) return;
    var w = document.createElement('div');
    w.className = 'a3-tblwrap';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  /* ---------- in-body YouTube facades (a.ark-ytf) ---------- */
  document.querySelectorAll('a.ark-ytf').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var id = b.getAttribute('data-yt');
      if (!id) return;
      e.preventDefault();
      var d = document.createElement('div');
      d.style.cssText = 'position:relative;padding-top:56.25%;border-radius:8px;overflow:hidden;border:1px solid rgba(28,26,27,.16);background:#1c1a1b';
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = b.getAttribute('aria-label') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture';
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      f.allowFullscreen = true;
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
      d.appendChild(f);
      b.replaceWith(d);
      track('video_play', {});
    });
  });

  renderCalc();
})();
